
// @ts-nocheck
import locale__src_locale_hr_js from "../locale/hr.js";
import locale__src_locale_en_js from "../locale/en.js";
import locale__src_locale_de_js from "../locale/de.js";
import locale__src_locale_it_js from "../locale/it.js";
import locale__src_locale_sl_js from "../locale/sl.js";
import locale__src_locale_nl_js from "../locale/nl.js";


export const localeCodes =  [
  "hr",
  "en",
  "de",
  "it",
  "sl",
  "nl"
]

export const localeLoaders = {
  "hr": [{ key: "../locale/hr.js", load: () => Promise.resolve(locale__src_locale_hr_js), cache: true }],
  "en": [{ key: "../locale/en.js", load: () => Promise.resolve(locale__src_locale_en_js), cache: true }],
  "de": [{ key: "../locale/de.js", load: () => Promise.resolve(locale__src_locale_de_js), cache: true }],
  "it": [{ key: "../locale/it.js", load: () => Promise.resolve(locale__src_locale_it_js), cache: true }],
  "sl": [{ key: "../locale/sl.js", load: () => Promise.resolve(locale__src_locale_sl_js), cache: true }],
  "nl": [{ key: "../locale/nl.js", load: () => Promise.resolve(locale__src_locale_nl_js), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.options.ts?hash=ef6a39e1&config=1" /* webpackChunkName: "__i18n_options_ts_ef6a39e1" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.options.ts",
  "locales": [
    {
      "code": "hr",
      "files": [
        "/src/locale/hr.js"
      ]
    },
    {
      "code": "en",
      "files": [
        "/src/locale/en.js"
      ]
    },
    {
      "code": "de",
      "files": [
        "/src/locale/de.js"
      ]
    },
    {
      "code": "it",
      "files": [
        "/src/locale/it.js"
      ]
    },
    {
      "code": "sl",
      "files": [
        "/src/locale/sl.js"
      ]
    },
    {
      "code": "nl",
      "files": [
        "/src/locale/nl.js"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": "locale/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "hr",
    "files": [
      {
        "path": "/src/locale/hr.js"
      }
    ]
  },
  {
    "code": "en",
    "files": [
      {
        "path": "/src/locale/en.js"
      }
    ]
  },
  {
    "code": "de",
    "files": [
      {
        "path": "/src/locale/de.js"
      }
    ]
  },
  {
    "code": "it",
    "files": [
      {
        "path": "/src/locale/it.js"
      }
    ]
  },
  {
    "code": "sl",
    "files": [
      {
        "path": "/src/locale/sl.js"
      }
    ]
  },
  {
    "code": "nl",
    "files": [
      {
        "path": "/src/locale/nl.js"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
